import { ErrorCode } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import OverlayTip from '@/components/overlay/OverlayTip'
import OverlayQrCode from '@/components/overlay/OverlayQrCode'
import OverlayPassword from '@/components/overlay/OverlayPassword'
import OverlayOnlyWeixin from '@/components/overlay/OverlayOnlyWeixin'
import Breakpoint from '@/components/overlay/Breakpoint'
import OverlayRestart from '@/components/overlay/OverlayRestart'
import MessageBox from '@/components/overlay/ErrorMessageBox.vue'
import AgreeInfo from '@/components/overlay/AgreeInfo.vue'

const map = new WeakMap()

export function overlay({ code, message, data }) {
  if (code === ErrorCode.FansNormal) {
    createPopup(OverlayTip, {
      text: message
    })
  } else if (code === ErrorCode.FansQr) {
    createPopup(OverlayQrCode, {
      url: data,
      text: message
    })
  } else if (code === ErrorCode.PASSWORD) {
    let vm = map.get(OverlayPassword)
    if (!vm) {
      vm = createPopup(OverlayPassword)
      vm.$on('close', () => {
        map.delete(OverlayPassword)
      })
    }
    vm.onUpdate(message, data)
    map.set(OverlayPassword, vm)
  } else if (code === ErrorCode.ONLY_WEIXIN) {
    createPopup(OverlayOnlyWeixin)
  } else if (code === ErrorCode.BREAKPOINT) {
    return createPopup(Breakpoint, { data })
  } else if (code === ErrorCode.RESTART) {
    return createPopup(OverlayRestart)
  } else if (code === ErrorCode.ERROR_MESSAGE_OVERLAY) {
    return createPopup(MessageBox, { data })
  } else if (code === ErrorCode.AGREE_INFO) {
    return createPopup(AgreeInfo, { option: data })
  }
}
